import { useEffect } from 'react';

const UseMinkaAllocateLedgerRegister = () => {
  useEffect(() => {}, []);

  return {};
};
export default UseMinkaAllocateLedgerRegister;
